import React, { Component } from "react";
import { connect } from "react-redux";

import projectSettings from "../../assets/Js/projectSettings";

import { getPlainToken } from "../../assets/Js/tokenHandler";

import { apiResponseToast } from "../../assets/Js/apiResponseToast";

import { callAPI } from "../../assets/Js/backendCommunication";

import { closeModel } from "../../assets/Js/closeModel";

import trackChanged from "../../redux/actionCreators/trackChanged";
import deleteConfirmationPrompt from "../../assets/Js/deleteConfirmationPrompt";
import GymCard from "./GymCard";
import NoInfoFound from "../../Components/NoInfoFound/NoInfoFound";

const mapStateToProps = (state) => {
  return {
    gymData: state.gymData,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    TrackGymDeleted: () => dispatch(trackChanged()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class MyGyms extends Component {
    constructor() {
      super();
      this.state = {
        addGym: 0,
        whichAccount: "",
        gyms: [],
        selectedGymInfo: {},
      };
    }

    componentDidMount() {
      if (this.props.gymData) this.getGym();
    }

    componentDidUpdate(prevState, nextState) {
      if (prevState.gymData !== this.props.gymData) this.getGym();
    }

    getGym = async () => {
      this.setState({
        gyms: this.props.gymData,
      });
    };

    handleAddGym = () => {
      this.setState({
        addGym: 1,
      });
      this.props.forward();
    };

    handleSetNext = (state) => {
      this.setState({
        addGym: 2,
      });
    };

    leaveGymApi = async () => {
      const athleteId = this.props.userData.Id;
      const gymId = this.state.selectedGymInfo.Id;

      let url = `${projectSettings.baseUrl}/gyms/removeuser/${gymId}`;
      let header = true;
      let type = "POST";
      let token = getPlainToken();
      let data = {};

      let response = "";

      data.userIds = [athleteId];

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, JSON.stringify(data), token);

      if (response) {
        apiResponseToast(response.status, "removeGym", response.data.message);

        this.setState({ isLoading: false });
        if (response.type === "error") {
        } else if (response.type === "success") {
          this.props.TrackGymDeleted();
          this.props.resetOnCloseModal();
          closeModel(this.props.modalId);

          response = "";
        }
      }
    };

    selectGym = async (data) => {
      await this.setState({
        selectedGymInfo: data,
      });
    };

    leaveGym = async (gymInfo) => {
      await this.selectGym(gymInfo);
      deleteConfirmationPrompt(this.leaveGymApi);
    };

    manageTrack = (gymInfo) => {
      let gymId = gymInfo.Id;

      this.props.handleSelectedGym(gymId);
    };

    render() {
      return (
        <>
          <div className={`dashboardTableSection`}>
            <div className="table-responsive mt-2">
              {this.state.gyms.length ? (
                <table className="table table-striped text-center">
                  <thead>
                    <tr className="rounded-top pt-2 pb-2">
                      <th>Gym Name</th>
                      <th>Role</th>
                      <th>Primary</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="primaryScrollBar tertiaryScrollBar">
                    {this.state.gyms.map((item, index) => (
                      <GymCard
                        key={index}
                        gymInfo={item}
                        manageTrack={this.manageTrack}
                        leaveGym={this.leaveGym}
                      />
                    ))}
                  </tbody>
                </table>
              ) : (
                <NoInfoFound text="No Gym Joined" />
              )}
            </div>
            <div className="float-right width-fit-content mx-auto mt-3">
              <button
                className={`basicFatBtnStyle quaternaryColor colorDark  mr-2`}
                data-dismiss="modal"
                onClick={this.props.resetOnCloseModal}
              >
                Cancel
              </button>

              <button
                onClick={this.handleAddGym}
                className="basicFatBtnStyle primaryBtn pl-2 pr-2"
              >
                <i className="mdi mdi-plus"></i>
                Add Track
              </button>
            </div>
          </div>
        </>
      );
    }
  }
);
